/*
 * Copyright (C) 2016 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './maskWithDashboardButton.tpl.html';

angular
  .module('shared.maskWithDashboardButton', ['sbsf.constants'])
  /**
   * Controller for the mask template.
   */
  .controller('MaskWithDashboardButtonCtrl', function ($scope, $timeout, $state, VIEW_STATES) {
    // scope property used to show the mask
    $scope.showMask = false;

    /**
     * Function to show mask.
     */
    $scope.showMaskHandler = function () {
      $scope.showMask = true;
    };

    /**
     * Function to go to dashboard.
     */
    $scope.goToDashboard = function () {
      $scope.showMask = false;
      $state.go(VIEW_STATES.ADMIN_HOME);
    };

    // Watch the trigger property that is managed by the parent scope
    // for changes.  When true fire off the timeout to show the mask.  If false
    // clear the mask values including a queued timeout promise to show.
    $scope.$watch('trigger', function (newVal) {
      if (newVal) {
        $scope.showPromise = $timeout($scope.showMaskHandler, 500);
      } else {
        $scope.showMask = false;
        $timeout.cancel($scope.showPromise);
        $scope.showPromise = undefined;
      }
    });
  })
  /**
   * The directive for the mask view.
   */
  .directive('maskWithDashboardButton', function () {
    return {
      controller: 'MaskWithDashboardButtonCtrl',
      templateUrl: 'shared/maskWithDashboardButton/maskWithDashboardButton.tpl.html',
      restrict: 'E',
      scope: {
        trigger: '=',
        titleKey: '=',
        msgKey: '='
      }
    };
  });
